import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-small-screen',
  templateUrl: './small-screen.component.html',
  styleUrls: ['./small-screen.component.scss']
})
export class SmallScreenComponent {

}
